import { q, qo } from '../../../shared/dom';
import { money } from '../../../shared/format';
import { ctx2d, sizeCanvases } from './canvas';

/** Camada de cassino: fogonazo, moldura de ouro, contador de dinheiro e canhão de moedas. */

interface Coin { x: number; y: number; vx: number; vy: number; r: number; rot: number; vr: number; rest: boolean; }

let coinParts: Coin[] = [];
let coinRAF: number | null = null;

/** Fogonazo branco-dourado + moldura pulsando ao redor do palco. */
export function jackpot(): void {
  const f = q('#flash');
  f.classList.remove('go'); void f.offsetWidth; f.classList.add('go');
  q('#stage').classList.add('win');
}

export function clearJackpot(): void {
  q('#stage').classList.remove('win');
  const c = qo<HTMLCanvasElement>('#coins');
  if (c) ctx2d(c).clearRect(0, 0, c.width, c.height);
  if (coinRAF) cancelAnimationFrame(coinRAF);
  coinRAF = null; coinParts = [];
}

/** O valor sobe como o contador de uma máquina. */
export function rollMoney(el: HTMLElement, to: number): void {
  const t0 = performance.now(), dur = 1600;
  (function s(now: number) {
    const k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
    el.textContent = money(to * e);
    if (k < 1) requestAnimationFrame(s); else el.textContent = money(to);
  })(performance.now());
}

function drawCoin(x: CanvasRenderingContext2D, p: Coin, D: number): void {
  x.save(); x.translate(p.x, p.y);
  const w = Math.max(1.5 * D, p.r * Math.abs(Math.cos(p.rot)));
  const g = x.createLinearGradient(-p.r, -p.r, p.r, p.r);
  g.addColorStop(0, '#FFFBE6'); g.addColorStop(.4, '#FFCA43'); g.addColorStop(.72, '#B9801A'); g.addColorStop(1, '#FFE9A8');
  x.beginPath(); x.ellipse(0, 0, w, p.r, 0, 0, Math.PI * 2);
  x.fillStyle = g; x.fill();
  x.lineWidth = Math.max(1, 1.3 * D); x.strokeStyle = 'rgba(80,50,4,.8)'; x.stroke();
  if (w > p.r * .42) {                                  // de canto não se vê a face
    x.beginPath(); x.ellipse(0, 0, w * .64, p.r * .64, 0, 0, Math.PI * 2);
    x.lineWidth = Math.max(1, 1 * D); x.strokeStyle = 'rgba(120,80,10,.55)'; x.stroke();
    x.fillStyle = 'rgba(105,68,6,.9)';
    x.font = `800 ${Math.round(p.r * 1.1)}px Oxanium, ui-monospace, monospace`;
    x.textAlign = 'center'; x.textBaseline = 'middle';
    x.fillText('$', 0, p.r * .06);
  }
  x.restore();
}

/** Dois canhões das esquinas e um aguaceiro de cima; as moedas quicam e se empilham no chão. */
export function coinBlast(): void {
  const c = qo<HTMLCanvasElement>('#coins'); if (!c) return;
  const x = ctx2d(c);
  sizeCanvases();
  const W = c.width, H = c.height, D = devicePixelRatio;
  const mk = (px: number, py: number, vx: number, vy: number, r: number): Coin =>
    ({ x: px, y: py, vx, vy, r, rot: Math.random() * 6, vr: (Math.random() - .5) * .36, rest: false });

  coinParts = [];
  for (let i = 0; i < 80; i++) {
    const left = i % 2 === 0;
    coinParts.push(mk(left ? W * .06 : W * .94, H * 1.03,
      (left ? 1 : -1) * (2.4 + Math.random() * 4.6) * D,
      -(11 + Math.random() * 7.5) * D,
      (8 + Math.random() * 10) * D));
  }
  for (let i = 0; i < 100; i++) {
    coinParts.push(mk(Math.random() * W, -Math.random() * H * .7,
      (Math.random() - .5) * 1.8 * D, (2 + Math.random() * 3.4) * D, (7 + Math.random() * 11) * D));
  }

  if (coinRAF) cancelAnimationFrame(coinRAF);
  const floor = H - 4 * D;
  (function loop() {
    x.clearRect(0, 0, W, H);
    let moving = 0;
    coinParts.forEach(p => {
      if (!p.rest) {
        p.vy += .44 * D; p.x += p.vx; p.y += p.vy; p.rot += p.vr;
        if (p.y > floor - p.r) {
          p.y = floor - p.r; p.vy *= -.3; p.vx *= .58; p.vr *= .5;
          if (Math.abs(p.vy) < 1.5 * D) { p.rest = true; p.y = floor - p.r * (.45 + Math.random() * .55); }
        }
        if (p.x < -80 * D || p.x > W + 80 * D) p.rest = true;
        moving++;
      }
      drawCoin(x, p, D);
    });
    coinRAF = moving ? requestAnimationFrame(loop) : null;
  })();
}
